var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isInDynamicContentsList)?_c('DynamicContent',{key:_vm.path,attrs:{"path":_vm.path},on:{"loaded":_vm.onContentLoaded}}):_c('NotFound')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }